import { getBillingDocumentStatus, type BillingDeliveryKind, type BillingDocumentStatus } from '../../api/billingDeliveries';

export const BILLING_DOCUMENTS_CHANGED = 'showphaze:billing-documents-changed';
export const BILLING_DOCUMENT_LABELS: Record<BillingDeliveryKind, string> = {
  estimate: 'Estimate', depositInvoice: 'Deposit invoice', invoice: 'Invoice',
};
export const BILLING_STATUS_LABELS: Record<BillingDocumentStatus['status'], string> = {
  saved: 'Saved · no send confirmed', queued: 'Email queued', sent: 'Sent', partial: 'Partially sent · review recipients',
  failed: 'Email failed', suppressed: 'Email not delivered', test: 'Test inbox only', unconfirmed: 'Send not confirmed',
};
export function notifyBillingDocumentsChanged(eventId: string) {
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(BILLING_DOCUMENTS_CHANGED, { detail: { eventId } }));
}

/** The save response proves creation; only the authenticated status reader can confirm an email send. */
export async function billingDocumentConfirmation(input: {
  eventId: string; configurationId?: string; kind: BillingDeliveryKind; documentNumber?: string; sendRequested: boolean;
}): Promise<string> {
  notifyBillingDocumentsChanged(input.eventId);
  const label = BILLING_DOCUMENT_LABELS[input.kind];
  try {
    const result = await getBillingDocumentStatus(input.eventId, input.configurationId);
    const row = result.documents.find(doc => doc.kind === input.kind && (!input.documentNumber || doc.documentNumber === input.documentNumber));
    if (row && !result.truncated) return `${label} ${row.documentNumber} saved. ${BILLING_STATUS_LABELS[row.status]}.${row.sentTo.length ? ` Sent to: ${row.sentTo.join(', ')}.` : ''}${row.cc.length ? ` CC: ${row.cc.join(', ')}.` : ''} Open document history for the numbered PDF.`;
  } catch { /* A failed status lookup must not turn a successful save into a false send confirmation. */ }
  return `${label}${input.documentNumber ? ` ${input.documentNumber}` : ''} saved.${input.sendRequested ? ' Email delivery is not yet confirmed.' : ' No email requested.'} Check the saved document history for its number and delivery status.`;
}
